import { normalizeHistoryEntry } from "../../../../helpers/formHistory";

export const extractSummaryHtml = (payload) => {
  if (!payload) return null;
  if (typeof payload === "string") {
    return payload.trim() ? payload : null;
  }
  const html = payload.data;
  return typeof html === "string" && html.trim() ? html : null;
};

export const extractSummaryHistory = (payload) => {
  if (!payload || typeof payload === "string") return [];
  const list = payload.history;
  if (!Array.isArray(list) || !list.length) return [];
  return list.map(normalizeHistoryEntry).filter(Boolean);
};
